import React from 'react';
import { useFormContext } from 'react-hook-form';
import moment from 'moment';
import { getUserInfo } from '_utils/localData';
import './style.scss';

const getClosingText = (dateStr) => {
  if (!dateStr) return 'Closing in — days';
  const target = moment(dateStr).startOf('day');
  const today = moment().startOf('day');
  const diffDays = target.diff(today, 'days');

  if (diffDays < 0) return 'Closed';
  if (diffDays === 0) return 'Closing today';
  if (diffDays === 1) return 'Closing in 1 day';
  return `Closing in ${diffDays} days`;
};

export default function EventPreview() {
  const { watch } = useFormContext() || {};

  const formGroupId = watch ? watch('groupId') : null;
  const formTitle = watch ? watch('title') : '';
  const formDesc = watch ? watch('description') : '';
  const formLocation = watch ? watch('location') : '';
  const formClosingDate = watch ? watch('closingDate') : '';
  const formCollectionDate = watch ? watch('collectionDate') : '';
  const formTimeFrom = watch ? watch('timeFrom') : '';
  const formTimeTo = watch ? watch('timeTo') : '';
  const formBanners = watch ? watch('banners') : [];

  const userInfo = getUserInfo();
  const hostName = userInfo?.name || 'Host';

  const groupName = formGroupId?.label || formGroupId?.name || formGroupId?.value || 'CoBee Group';
  const title = formTitle || 'Your event title';
  const description = formDesc ? formDesc.trim() : '';
  const location = formLocation || '—';
  const closing = formClosingDate || '—';

  let collection = formCollectionDate || '—';
  if (formCollectionDate && (formTimeFrom || formTimeTo)) {
    collection = `${formCollectionDate} (${formTimeFrom || '10:00'} – ${formTimeTo || '17:00'})`;
  }

  const coverImage = formBanners?.[0]?.url || (typeof formBanners?.[0] === 'string' ? formBanners[0] : null);

  return (
    <div className="review-event-card">
      {/* Header */}
      <div className="review-event-header">
        <div className="author-info">
          <div className="avatar">
            {groupName.substring(0, 2).toUpperCase()}
          </div>
          <div className="group-meta">
            <div className="group-name">{groupName}</div>
            <div className="author-name">{hostName}</div>
          </div>
        </div>
        <div className="header-status">
          <span className="closing-days">{getClosingText(formClosingDate)}</span>
          <span className="buy-badge">0 BUY</span>
        </div>
      </div>

      {/* Cover / Image Area */}
      <div className="review-event-cover">
        {coverImage ? (
          <img src={coverImage} alt={title} className="cover-img" />
        ) : (
          <svg
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#80CCCB"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <polyline points="21 15 16 10 5 21" />
          </svg>
        )}
      </div>

      {/* Content Body */}
      <div className="review-event-content">
        <div className="event-title">{title}</div>
        {description && <div className="event-desc">{description}</div>}

        <div className="event-details-grid">
          <span className="detail-label">Closing:</span>
          <span className="detail-value">{closing}</span>
          <span className="detail-label">Collection:</span>
          <span className="detail-value">{collection}</span>
          <span className="detail-label">Address:</span>
          <span className="detail-value">{location}</span>
        </div>
      </div>
    </div>
  );
}
